module.exports = {
    url: '/dmd',
    views: {
        main: {
            controller: function ($scope) {
                'ngInject';
                $scope.patient = $scope.$parent.patient;
            },
            template: `
                <generate_access_code patient="patient"></generate_access_code>
          `
        },
        title: {
            controller: function () {
            },
            template: `
                Sharing Arrangements
      `
        }
    }
};
